import { render, staticRenderFns } from "./OperaFolderDialog.vue?vue&type=template&id=f03187d2&scoped=true&"
import script from "./OperaFolderDialog.vue?vue&type=script&lang=js&"
export * from "./OperaFolderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03187d2",
  null
  
)

export default component.exports